import { Phone, MessageCircle, ClipboardList } from "lucide-react";
import { Link } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";

const MobileBar = () => {
  const site = useSettings();
  
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-white/10 bg-brand-ink text-white md:hidden"
      data-testid="mobile-action-bar"
    >
      <a
        href={site.phoneLink}
        data-testid="mobile-bar-call"
        className="flex h-14 flex-col items-center justify-center gap-0.5 text-[10px] font-mono uppercase tracking-widest active:bg-white/10"
      >
        <Phone size={17} /> Call
      </a>
      <a
        href={site.whatsappLink}
        target="_blank"
        rel="noreferrer"
        data-testid="mobile-bar-whatsapp"
        className="flex h-14 flex-col items-center justify-center gap-0.5 border-x border-white/10 text-[10px] font-mono uppercase tracking-widest active:bg-white/10"
      >
        <MessageCircle size={17} /> WhatsApp
      </a>
      <Link
        to="/inquiry"
        data-testid="mobile-bar-inquiry"
        className="flex h-14 flex-col items-center justify-center gap-0.5 bg-brand-red text-[10px] font-mono uppercase tracking-widest active:bg-brand-reddark"
      >
        <ClipboardList size={17} /> Inquiry
      </Link>
    </nav>
  );
};

export default MobileBar;
